<template>
  <v-form ref="form">
    <v-layout row wrap>
      <v-flex xs12 md4>
        <SelectPuntoVenta
          :model="itemActivo.Id_PuntoVenta"
          :rules="rules"
          :loading="loading"
          @seleccionarItem="seleccionarPuntoVenta"
        />
      </v-flex>
      <v-flex xs6 md2>
        <Fecha
          label="Fecha*"
          :fecha="itemActivo.Fecha"
          :rules="rules"
          @seleccionarItem="seleccionarFecha"
        />
      </v-flex>
      <v-flex xs6 md6>
        <v-layout>
          <v-flex>
            <v-card
              class="clickable pa-1 overline"
              v-ripple="{ center: true }"
              @click="ejecutarAccion('Buscar', 1)"
            >
              <v-icon>looks_one</v-icon>Mañana
              <span v-if="itemActivo.Id_Caja && itemActivo.Turno == 1">
                <small> Nº {{ itemActivo.Id_Caja }} </small>
                <v-chip
                  v-if="itemActivo.Estado == null || itemActivo.Estado == 'P'"
                  small
                  color="error"
                  >{{ iEstado }}</v-chip
                >
                <v-chip v-if="itemActivo.Estado == 'C'" small color="warning">{{
                  iEstado
                }}</v-chip>
                <v-chip v-if="itemActivo.Estado == 'A'" small color="success">{{
                  iEstado
                }}</v-chip>
                <br />
                <small>
                  {{ itemActivo.NombreEmpleado }}
                </small>
              </span>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card
              class="clickable pa-1 overline"
              v-ripple="{ center: true }"
              @click="ejecutarAccion('Buscar', 2)"
            >
              <v-icon>looks_two</v-icon>Tarde
              <span v-if="itemActivo.Id_Caja && itemActivo.Turno == 2">
                - Nº {{ itemActivo.Id_Caja }}
                <v-chip
                  v-if="itemActivo.Estado == null || itemActivo.Estado == 'P'"
                  small
                  color="error"
                  >{{ iEstado }}</v-chip
                >
                <v-chip v-if="itemActivo.Estado == 'C'" small color="warning">{{
                  iEstado
                }}</v-chip>
                <v-chip v-if="itemActivo.Estado == 'A'" small color="success">{{
                  iEstado
                }}</v-chip>
                <br />
                {{ itemActivo.NombreEmpleado }}
              </span>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card
              class="clickable pa-1 overline"
              v-ripple="{ center: true }"
              @click="ejecutarAccion('Buscar', 3)"
            >
              <v-icon>looks_3</v-icon>Noche
              <span v-if="itemActivo.Id_Caja && itemActivo.Turno == 3">
                - Nº {{ itemActivo.Id_Caja }}
                <v-chip
                  v-if="itemActivo.Estado == null || itemActivo.Estado == 'P'"
                  small
                  color="error"
                  >{{ iEstado }}</v-chip
                >
                <v-chip v-if="itemActivo.Estado == 'C'" small color="warning">{{
                  iEstado
                }}</v-chip>
                <v-chip v-if="itemActivo.Estado == 'A'" small color="success">{{
                  iEstado
                }}</v-chip>
                <br />
                {{ itemActivo.NombreEmpleado }}
              </span>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-form>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import Mensaje from "@/components/Mensaje";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import Fecha from "@/components/Fecha";
export default {
  name: "SelectCaja",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  components: {
    SelectPuntoVenta,
    Mensaje,
    Fecha
  },
  data() {
    return {
      rutaApi: "Caja/",
      itemVacio: {
        Id_Caja: 0,
        Id_PuntoVenta: 0,
        NombrePuntoVenta: "",
        Fecha: "",
        Turno: "",
        NombreEmpleado: "",
        Estado: ""
      },
      itemActivo: {},
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor > 0)
          this.$emit("seleccionarItem", this.itemActivo);
      }
    },
    iFecha() {
      return this.itemActivo.Fecha
        ? moment(this.itemActivo.Fecha)
            .locale("es-AR")
            .format("L")
        : "";
    },
    iEstado() {
      let estado;
      switch (this.itemActivo.Estado) {
        case null:
          estado = "Abierto";
          break;
        case "P":
          estado = "Cortado";
          break;
        case "C":
          estado = "Cerrado";
          break;
        case "A":
          estado = "Verificado";
          break;
      }
      return estado;
    }
  },
  created() {
    eventBus.$on("setearFocoSelectCaja", this.setearFoco);
    eventBus.$on("inicializarSelectCaja", this.inicializar);
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectCaja", this.setearFoco);
    eventBus.$off("inicializarSelectCaja", this.inicializar);
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("inicializarSelectPuntoVenta");
      }, 100);
      setTimeout(() => {
        eventBus.$emit("inicializarFecha");
      }, 100);
      this.setearFoco();
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.NombrePuntoVenta;
      this.limpiar();
    },
    seleccionarFecha(item) {
      this.itemActivo.Fecha = item.Fecha;
      this.itemActivo.Id_Caja = 0;
    },
    limpiar() {
      this.iModel = this.itemActivo.Id_Caja = 0;
      this.itemActivo.NombreEmpleado = "";
    },
    ejecutarAccion(accion, turno) {
      this.accion = accion;
      switch (accion) {
        case "Buscar":
          if (this.$refs.form.validate()) this.buscar(turno);
          break;
        case "CancelarMensaje":
          this.mostrarMensaje(false);
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    buscar(turno) {
      this.loading = true;
      this.limpiar();
      HttpHelper.get(this.rutaApi + "BuscarTurno", {
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        fecha: this.itemActivo.Fecha,
        turno: turno
      })
        .then(response => {
          if (response.data.Resultado == "OK") {
            this.itemActivo = response.data;
            this.iModel = this.itemActivo.Id_Caja;
          } else {
            this.$emit("seleccionarItem", this.itemActivo);
            this.mostrarMensaje(
              true,
              "Mensaje",
              "El turno " + this.iFecha + "-" + turno + " no existe",
              "Verifique el turno e intente nuevamente."
            );
          }
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectPuntoVenta");
      }, 100);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
